import { configureStore } from "@reduxjs/toolkit";

// Import the rootReducer to have all reducers available within the store
import rootReducer from "../reducers";

// Create the redux store with configureStore and pass the reducer property and its value which is the rootReducer that combines all reducers
const store = configureStore ({
    reducer: rootReducer,
});


export default store;
